import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe';
import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getIdViaChannelYt, getIdViaHandler } from 'api_handlers/discovery';
import { getDiscoveryInfluencersDetails } from 'api_handlers/planner2';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import mixpanel from 'utils/mixpanel';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function InsightFrame() {
  const platform = window.location.pathname.split('/')[3];
  const influencer_handler = window.location.pathname.split('/')[4];
  const classes = useStyle();
  const [getId, setGetId] = useState(null);
  const [updateStatus, setUpdateStatus] = useState('');
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const fetchDetails = async () => {
    if (getId) {
      getDiscoveryInfluencersDetails(getId).then((response) => {
        if (response?.update_status === 'updating') {
          setUpdateStatus('updating');
        }
        if (response?.update_status === 'updated') {
          setUpdateStatus('updated');
        }
      });
    }
  };

  if (!getId) {
    if (platform === 'youtube') {
      getIdViaChannelYt(influencer_handler).then((res) => {
        setGetId(res.data.id);
      });
    } else if (platform === 'instagram') {
      getIdViaHandler(influencer_handler).then((res) => {
        setGetId(res.data.id);
      });
    }
  }

  useEffect(() => {
    fetchDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getId]);

  // Every profile view counts here — direct hits, reloads and shared links included,
  // not just the click in the list that opened this tab.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    mixpanel.track('Insights viewed', {
      url: window.location.pathname,
      type: params.get('type') || 'direct',
      source: params.get('src') || 'direct',
      platform,
      handle: influencer_handler,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fallback: hide loader after 10s in case iframe onLoad doesn't fire
  useEffect(() => {
    const t = setTimeout(() => setIframeLoaded(true), 10000);
    return () => clearTimeout(t);
  }, []);

  return (
    <Grid container sx={{ position: 'relative', minHeight: 400 }}>
      {!iframeLoaded && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#F4F5FA',
            zIndex: 10,
          }}
        >
          <CircularProgress size={48} sx={{ color: '#4F46E5' }} />
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Loading profile details...
          </Typography>
        </Box>
      )}
      <Grid item md={12} sx={{ width: '100%' }}>
        <Iframe
          url={`/planner/profile/${platform}/${influencer_handler}`}
          width="100%"
          height={`${window.matchMedia('(min-height: 2600px)') ? '2600px' : '770px'}`}
          frameBorder="0"
          className={classes.frameStyle}
          onLoad={() => setIframeLoaded(true)}
        />
        {
          updateStatus ? 
          <React.Fragment>
          <BootstrapDialog
            onClose={()=>{
              setUpdateStatus('')
            }}
            aria-labelledby="customized-dialog-title"
            open={updateStatus === 'updating'}
            fullWidth
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={()=>{
                setUpdateStatus('')
              }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              We are updating the data for this profile, Please come back later
            </DialogContent>
          </BootstrapDialog>
          </React.Fragment>
          : null
        }
      </Grid>
    </Grid>
  );
}

const useStyle = makeStyles(() => ({
  frameStyle: {
    
  },
}));
